import tilesheet from '../assets/maps/sheet.json'
import sheet from '../assets/images/sheet.png'

const image = new Image()
image.src = sheet

function GameMap() {
  return kontra.sprite({
    tickCounter: 0,

    layers: Maps[selectedMap].layers.map(layer => ({
      ...layer,
      data: layer.data.map(tile => {
        const tileData = tilesheet.tiles.find(x => x.id === tile - 1)
        if (tileData && tileData.properties) {
          const type = tileData.properties.find(x => x.name === 'type').value
          return {
            id: tile - 1,
            type
          }
        } else {
          return { id: tile - 1 }
        } 
      })
    })),

    getTile(layerIndex, x, y) {
      const layer = this.layers[layerIndex]
      return layer.data[y * layer.width + x]
    },

    setTile(layerIndex, x, y, id) {
      const layer = this.layers[layerIndex]
      layer.data[y * layer.width + x].id = id
    },

    setTileByFlatPos(layerIndex, flatPos, id) {
      const layer = this.layers[layerIndex]
      layer.data[flatPos].id = id
    },

    update() {},

    render() {
      for (const layer of this.layers) {
        layer.data.forEach((tile, i) => {
          if (tile.id === -1) {
            return
          }

          const { columns, tilewidth, tileheight } = tilesheet
          const sx = tile.id % columns
          const sy = Math.floor(tile.id / columns)
          const x = i % Maps[selectedMap].width
          const y = Math.floor(i / Maps[selectedMap].width)
          this.context.drawImage(
            image,
            sx * tilewidth, sy * tileheight, tilewidth, tileheight,
            x * tilewidth, y * tileheight, tilewidth, tileheight
          )
        })
      }
    }
  })
}

export default GameMap